'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('../../_commonjsHelpers-6ecf82ef.js');
require('../../extends-733dd656.js');
require('../../objectWithoutProperties-c6d3675c.js');
var React = require('react');
var index = require('../../index-7124f64c.js');
require('../../taggedTemplateLiteral-f923b98d.js');
var styled = require('styled-components');
require('../../xstyled-styled-components.es-6e2bde7d.js');
require('../../extends-5ede7877.js');
require('../../xstyled-prop-types.es-4220f7f4.js');
require('../../unsupportedIterableToArray-f175acfa.js');
require('../../breakpoints-ee0a4ae5.js');
require('../GlobalStyle/GlobalStyle.js');
require('../../utils/env/isTestEnv/isTestEnv.js');
require('../../utils/env/isBrowserEnv/isBrowserEnv.js');
require('../../utils/env/isProdEnv/isProdEnv.js');
require('../../utils/logger/logDeprecatedFeature/logDeprecatedFeature.js');
require('../../theme-80c5a73f.js');
require('../../polished.esm-8ddeb0a5.js');
require('../../colorBuilder-8c1a81a8.js');
require('../NuDSProvider/NuDSProvider.js');
require('../../utils/isType/isType.js');
require('../../defineProperty-3cad0327.js');
var styles_themeUtils = require('../../styles/themeUtils.js');
require('../../Icon-efcd1bee.js');
require('../../styles/colors/colorVariantsShape.js');
require('../../utils/i18n/maybeFormatMessage.js');
require('../../utils/i18n/maybeFormatPrefixedMessage.js');
require('../../utils/intl/intlAriaAttrs.js');
require('../../utils/hooks/useIntlAriaAttrs.js');
var components_Typography_Typography = require('../Typography/Typography.js');
var components_Link_Link = require('../Link/Link.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var Radio = styled__default['default'].span.withConfig({
  displayName: "RadioLink__Radio",
  componentId: "sc-16iqhy7-0"
})(["align-items:center;box-sizing:border-box;border:2.5px solid ", ";border-radius:50%;display:flex;height:18px;justify-content:center;margin-right:", "px;width:18px;"], styles_themeUtils.nuDSColor('white', 'dark'), 0.5 * 16);
Radio.displayName = 'Radio';

function activeStyle() {
  return styled.css(["", "{border-color:inherit;&::before{background-color:inherit;border-radius:50%;content:\"\";display:block;height:6px;width:6px;}}"], Radio);
}

var StyledNuLink = styled__default['default'](components_Link_Link['default']).withConfig({
  displayName: "RadioLink__StyledNuLink",
  componentId: "sc-16iqhy7-1"
})(["color:", ";text-decoration:none;", ";&:hover,&:focus{color:", ";", ";", "{border-color:", ";&::before{background-color:", ";}}}"], styles_themeUtils.nuDSColor('white', 'dark'), function (_ref) {
  var isActive = _ref.isActive;
  return isActive && styled.css(["", ";", "{&::before{background-color:", ";}}"], activeStyle, Radio, styles_themeUtils.nuDSColor('white', 'dark'));
}, styles_themeUtils.nuDSColor('primary', 'light'), activeStyle, Radio, styles_themeUtils.nuDSColor('primary', 'light'), styles_themeUtils.nuDSColor('primary', 'light'));
StyledNuLink.displayName = 'StyledNuLink';

function RadioButton(_ref) {
  var ariaLabel = _ref.ariaLabel,
      forceRefresh = _ref.forceRefresh,
      route = _ref.route,
      locale = _ref.locale,
      onClick = _ref.onClick,
      isActive = _ref.isActive,
      children = _ref.children;
  return /*#__PURE__*/React__default['default'].createElement(StyledNuLink, {
    "aria-label": ariaLabel,
    forceRefresh: forceRefresh,
    href: route,
    hrefLang: locale,
    isActive: isActive,
    locale: locale,
    onClick: onClick
  }, /*#__PURE__*/React__default['default'].createElement(Radio, {
    isActive: isActive
  }), /*#__PURE__*/React__default['default'].createElement(components_Typography_Typography['default'], {
    color: "inherit",
    variant: "text1"
  }, children));
}

RadioButton.defaultProps = {
  ariaLabel: null,
  forceRefresh: false,
  isActive: false,
  locale: null,
  onClick: null
};
RadioButton.propTypes = {
  ariaLabel: index.propTypes.string,
  children: index.propTypes.node.isRequired,
  forceRefresh: index.propTypes.bool,
  isActive: index.propTypes.bool,
  locale: index.propTypes.string,
  onClick: index.propTypes.func,
  route: index.propTypes.string.isRequired
};

exports.default = RadioButton;
//# sourceMappingURL=RadioButton.js.map
